import { z } from "zod";

export const ProfileSubPage = z.enum([
    "benefits",
    "delete-account",
    "feedback",
    "survey-permissions",
    "terms-and-conditions",
    "privacy-policy",
]);
export type ProfileSubPage = z.infer<typeof ProfileSubPage>;

export const ProfileSubPageReadyMessage = z.object({
    type: z.literal("profileSubPage.ready"),
});
export type ProfileSubPageReadyMessage = z.infer<typeof ProfileSubPageReadyMessage>;

/** Same shape the shared mini-app `useNavigateBack` hook already posts. */
export const ProfileSubPageNavigateBackMessage = z.object({
    type: z.literal("navigateBack"),
});
export type ProfileSubPageNavigateBackMessage = z.infer<
    typeof ProfileSubPageNavigateBackMessage
>;

export const ProfileSubPageOpenMessage = z.object({
    type: z.literal("profileSubPage.open"),
    subPage: ProfileSubPage,
});
export type ProfileSubPageOpenMessage = z.infer<typeof ProfileSubPageOpenMessage>;

export const ProfileSubPageOpenChatMessage = z.object({
    type: z.literal("profileSubPage.openChat"),
});
export type ProfileSubPageOpenChatMessage = z.infer<
    typeof ProfileSubPageOpenChatMessage
>;

/** Mini-apps have no PostHog client; the host records the event. */
export const ProfileSubPageFeedbackSubmittedMessage = z.object({
    type: z.literal("profileSubPage.feedbackSubmitted"),
});
export type ProfileSubPageFeedbackSubmittedMessage = z.infer<
    typeof ProfileSubPageFeedbackSubmittedMessage
>;

export const ProfileSubPageMessage = z.discriminatedUnion("type", [
    ProfileSubPageReadyMessage,
    ProfileSubPageNavigateBackMessage,
    ProfileSubPageOpenMessage,
    ProfileSubPageOpenChatMessage,
    ProfileSubPageFeedbackSubmittedMessage,
]);
export type ProfileSubPageMessage = z.infer<typeof ProfileSubPageMessage>;

export function parseProfileSubPageMessageData(
    data: unknown,
): ProfileSubPageMessage | null {
    const parsed = ProfileSubPageMessage.safeParse(data);
    return parsed.success ? parsed.data : null;
}
